import { useState } from 'react';
import ContactForm from './ContactForm';

export default function Footer() {
  const [showForm, setShowForm] = useState(false);

  return (
    <>
      <footer id="contact" className="bg-gradient-to-br from-purple-600 via-purple-700 to-purple-800 text-white py-20">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
            <div>
              <img
                src="https://static.readdy.ai/image/697e6f77929f9088e365751998e03758/314605e4b4e6a02bbfa1f915d9b9c8cf.jpeg"
                alt="Soul One Digital"
                className="h-16 w-auto object-contain mb-6"
              />
              <p className="text-purple-100 font-light leading-relaxed">
                Traduzindo a alma das marcas para o mundo digital com estratégia, humanidade e excelência.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-light mb-6">Navegação</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => {
                      const element = document.getElementById('hero');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-purple-100 hover:text-white transition-colors font-light cursor-pointer"
                  >
                    Início
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      const element = document.getElementById('essence');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-purple-100 hover:text-white transition-colors font-light cursor-pointer"
                  >
                    Nossa Essência
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      const element = document.getElementById('solutions');
                      if (element) element.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-purple-100 hover:text-white transition-colors font-light cursor-pointer"
                  >
                    Soluções
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => setShowForm(true)}
                    className="text-purple-100 hover:text-white transition-colors font-light cursor-pointer"
                  >
                    Contato
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-light mb-6">Contato</h4>
              <div className="space-y-4">
                <button
                  onClick={() => setShowForm(true)}
                  className="flex items-center gap-3 text-purple-100 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line text-xl"></i>
                  <span className="font-light">contato@soulonedigital.com</span>
                </button>
                <a
                  href="https://wa.me/5511939328965"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 text-purple-100 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  <span className="font-light">(11) 93932-8965</span>
                </a>
                <div className="flex gap-4 mt-6">
                  <a
                    href="https://www.instagram.com/soulonedigital2026/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-all cursor-pointer"
                  >
                    <i className="ri-instagram-line text-xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-purple-500/30 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-purple-100 font-light text-sm">
                © 2025 Soul One Digital. Todos os direitos reservados.
              </p>
              <p className="text-purple-100 font-light text-sm">
                CNPJ: 00.000.000/0001-00
              </p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-purple-100 hover:text-white font-light text-sm transition-colors cursor-pointer"
              >
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>

      {showForm && <ContactForm onClose={() => setShowForm(false)} />}
    </>
  );
}
